<template>
  <router-view />
</template>

<script>
export default {
    name: "SuperAdmin",
    components: {},
    data() {
        return {};
    },
};
</script>

<style lang="scss">
</style>

